<div class="row" *ngIf="Breadcrumb!=null">
    <div class="col-12 p-0 border-bottom headersize">
      <app-breadcrumb [Breadcrumb1]="Breadcrumb" [File_Name1]="studymateriallist1.Study_Material_Name"></app-breadcrumb>
    </div>
  </div>
  <div class="row">
    
    <div class="col-12" style="height: 65vh !important; overflow: auto;">
        <div class="row">
            <div class="col-4 headersize1">Topic

            </div>
            <div class="col-2 headersize1">Coverage Rating

            </div>
            <div class="col-6 headersize1">Comment

            </div>

        </div>
     
        <div class="row">
                <div class="card mt-2"  *ngFor="let value of TopicList;let i = index">
                    <!-- <div class="card-body"> -->
                    
                        <div class="row">
                            <div class="d-flex p-0">
                                <div class="col-4 p-1">
                                    <textarea type="text" style="
                                    height: 75px;
                                " maxlength="4000"class="form-control form-control-sm"  [attr.disabled]="true" readonly="readonly" [(ngModel)]="value.TopicName"></textarea>
                                </div>
                                <div class="col-2 p-1">
                                    <select  class="form-control form-control-sm" id="Rating" name="Rating" [(ngModel)]="value.TopicCoverageRatingTypeCode"(change)="selectrating($event,i)">
                                        <option selected value="" hidden></option>
                                        <option class="border-bottom"  *ngFor="let s of getrating;let j=index" [value]="s.Code">{{s.Description}}</option>
                                    </select> 
                                </div>
                                <div class="col-6 p-1">
                                    <textarea type="text" style="
                                    height: 75px;
                                "maxlength="4000" class="form-control form-control-sm" id="Comments" name="Comments" [(ngModel)]="value.CoverageCommentText" (input)="EnterComments($event,i)"></textarea>
                                </div>
                            </div>
                            
                        </div>
                        
                    <!-- </div>   -->
                  
                </div>

         
            
        </div>
        <!-- <div class="row">
            <div class="col-4">
                <textarea type="text" maxlength="4000"class="form-control form-control-sm input-txt2" [attr.disabled]="true" readonly="readonly" [(ngModel)]="gettopic[i]"></textarea>
            </div>
            <div class="col-2">
                <select  class="form-control form-control-sm" [(ngModel)]="TopicList[i].TopicCoverageRatingTypeCode"(change)="selectrating($event,i)">
                    <option selected value="" hidden></option>
                    <option class="border-bottom"  *ngFor="let s of getrating;let j=index" [value]="s.Code">{{s.Description}}</option>
                </select> 
            </div>
            <div class="col-5">
                <textarea type="text" maxlength="4000" class="form-control form-control-sm" [(ngModel)]="TopicList[i].CoverageCommentText" (input)="EnterComments($event,i)"></textarea>
            </div>
        </div> -->
    
      <!-- <div class="row">
        <div class="col-4 headersize1">Topic
            <div class="row pt-1" *ngFor="let value of gettopic;let i = index" >
                <div class="col-12">
                   
                    <textarea type="text" style="
                    height: 70px;
                " maxlength="4000"class="form-control form-control-sm input-txt2" [attr.disabled]="true" readonly="readonly" [(ngModel)]="gettopic[i]"></textarea>
                
                </div>
            </div>

        </div>
        <div class="col-2  headersize1">Coverage Rating
            <div class="row pt-1" *ngFor="let value of gettopic;let j = index" >
                <div class="col-12">
                 
                <select  class="form-control form-control-sm" [(ngModel)]="TopicList[j].TopicCoverageRatingTypeCode"(change)="selectrating($event,j)">
                <option selected value="" hidden></option>
                <option class="border-bottom"  *ngFor="let s of getrating;let i=index" [value]="s.Code">{{s.Description}}</option>
               
              </select> 
             
            </div>
        </div>
        </div>
        <div class="col-6  headersize1">Comment
            <div class="row pt-1" *ngFor="let value of gettopic;let k = index" >
                <div class="col-12">
                   
                        
                    <textarea type="text" style="
                    height: 70px;
                " maxlength="4000" class="form-control form-control-sm" [(ngModel)]="TopicList[k].CoverageCommentText" (input)="EnterComments($event,k)"></textarea>
                  
                </div>
            </div>
        </div>

      </div> -->
      <div class="row pt-5">
        <div class="col-12 pb-2">
          <div class="d-flex justify-content-center">
            <div class="px-1">
              <button type="button" (click)="Save()" class="btn btn-sm bl-btn">Save</button>
            </div>
            <div class="px-1">
              <button type="button"  (click)="cancel()"class="btn btn-sm bg-light border">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <!-- <div class="col-12">
        
        </div> -->
 
  </div>